module.exports = __webpack_public_path__ + "img/蒙版组 58.eb219436.png";